import type { ReactNode } from 'react'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

import { cn } from '@/lib/utils'

import '@/components/organisms/markdown-editor/markdown-editor.css'

type MarkdownContentSize = 'sm' | 'base'

interface MarkdownContentProps {
  content: string
  size?: MarkdownContentSize
  className?: string
}

const sizeClassMap: Record<MarkdownContentSize, string> = {
  sm: 'saaga-wysiwyg-sm',
  base: '',
}

const remarkPluginList = [remarkGfm]

export const MarkdownContent = ({
  content,
  size = 'base',
  className,
}: MarkdownContentProps): ReactNode => {
  if (!content) {
    return null
  }

  return (
    <div className={cn('saaga-wysiwyg', sizeClassMap[size], className)}>
      <Markdown remarkPlugins={remarkPluginList}>{content}</Markdown>
    </div>
  )
}

MarkdownContent.displayName = 'MarkdownContent'
